import { render, staticRenderFns } from "./reginImageItem.vue?vue&type=template&id=405427a6&scoped=true&"
import script from "./reginImageItem.vue?vue&type=script&lang=js&"
export * from "./reginImageItem.vue?vue&type=script&lang=js&"
import style0 from "./reginImageItem.vue?vue&type=style&index=0&id=405427a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405427a6",
  null
  
)

export default component.exports